/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://portal-can01.mitellabs.com:8443';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
